// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2VYGo","productName":"Table_productName__VYSfT"};